import React from "react";
import { Table, Typography, Button } from "antd";

const ScheduleTable = () => {
  const { Text } = Typography;

  // Dummy data
  const data = [
    {
      key: "1",
      teacher: "Akhil",
      subject: "Math",
      Mon: "9 AM (1 hour)",
      Tues: "10 AM (1.5 hours}",
      Wed: "11 AM (2 hours}",
      Thur: "12 PM (1 hour)",
      Fri: "1 PM (1 hour)",
      Sat: "2 PM (1 hour)",
      Sun: "3 PM (1 hour)",
    },
    {
      key: "2",
      teacher: "Vineet",
      subject: "Physics",
      Mon: "9 AM (1 hour)",
      Tues: "10 AM (1.5 hours}",
      Wed: "11 AM (2 hours)",
      Thur: "12 PM (1 hour)",
      Fri: "1 PM (1 hour)",
      Sat: "2 PM (1 hour)",
      Sun: "3 PM (1 hour)",
    },
    // Add more teachers and subjects as needed
  ];

  // Columns configuration
  const columns = [
    {
      title: "Teacher",
      dataIndex: "teacher",
      key: "teacher",
      fixed: "left",
      render: (text, record) => (
        <div>
          <Text strong>{text}</Text>
          <br />
          <Text type='secondary'>{record.subject}</Text>
        </div>
      ),
    },
    {
      title: "Mon",
      dataIndex: "Mon",
      key: "Mon",
    },
    {
      title: "Tues",
      dataIndex: "Tues",
      key: "Tues",
    },
    {
      title: "Wed",
      dataIndex: "Wed",
      key: "Wed",
    },
    {
      title: "Thur",
      dataIndex: "Thur",
      key: "Thur",
    },
    {
      title: "Fri",
      dataIndex: "Fri",
      key: "Fri",
    },
    {
      title: "Sat",
      dataIndex: "Sat",
      key: "Sat",
    },
    {
      title: "Sun",
      dataIndex: "Sun",
      key: "Sun",
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        bordered
        size='middle'
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      <Button type='primary' className='book-now-btn'>
        Book Now
      </Button>
    </>
  );
};

export default ScheduleTable;
